export default __webpack_public_path__ + "static/media/surroundings.1ca3356e.svg";